<ul  [hidden]="!openEmails">
  <li *ngFor="let user of users">
    <core-helper-box-user-email [user]="user" (click)="onSelect(user)"></core-helper-box-user-email>
  </li>
</ul>
